import { POG__ZONE_COLORS, POG__ZONE_FALLBACK_COLOR, POG__ZONE_LABELS } from "./constants";

function POG__getZoneLabel(symbol: string | null | undefined): string {
	if (symbol === null || symbol === undefined || symbol === "") {
		return "—";
	}
	return POG__ZONE_LABELS[symbol] ?? symbol;
}

function POG__getZoneColor(symbol: string | null | undefined): string {
	if (symbol === null || symbol === undefined || symbol === "") {
		return POG__ZONE_FALLBACK_COLOR;
	}
	return POG__ZONE_COLORS[symbol] ?? POG__ZONE_FALLBACK_COLOR;
}

export { POG__getZoneColor, POG__getZoneLabel };
